import React, { useEffect, useRef, useState } from 'react';
import { Card, CardBody, Col, Row, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { MDBDataTable } from 'mdbreact';
import isEqual from 'lodash/isEqual';

const DataTable = ({ title, tableData, id, popoverTitle, popoverBody }) => {
  const ref = useRef();
  const [showPopover, setShowPopover] = useState(false);

  const handleShowPopover = () => {
    setShowPopover(true)
  }

  const handleHidePopover = () => {
    setShowPopover(false)
  }

  useEffect(() => {
    // Custom JS to rename certain labels
    const showEntries = ref.current.querySelector('.dataTables_length label');
    if (showEntries)
      showEntries.innerHTML = showEntries.innerHTML.replace('Show entries', 'Elementos por página');

    const searchLabel = ref.current.querySelector('.dataTables_filter label');
    if (searchLabel)
      searchLabel.innerHTML = searchLabel.innerHTML.replace('Search', 'Buscar');

    const searchBar = ref.current.querySelector('.dataTables_filter label input');
    if (searchBar)
      searchBar.setAttribute('placeholder', 'Buscar');

    const searchBar2 = ref.current.querySelector('.mdb-datatable-filter input');
    if (searchBar2)
      searchBar2.setAttribute('placeholder', 'Buscar');

  }, []);

  return (
    <Card innerRef={ref}>
      <CardBody>
        <Row>
          <Col lg={8} md={8}>
            <h5>{title}</h5>
          </Col>
          <Col lg={4} md={4}>
            <i className="fas fa-question-circle float-right pointer" id={id} onClick={handleShowPopover}></i>
            <Popover placement="bottom" isOpen={showPopover} target={id} toggle={handleHidePopover}>
              <PopoverHeader>{popoverTitle}</PopoverHeader>
              <PopoverBody>{popoverBody}</PopoverBody>
            </Popover>
          </Col>
        </Row>
        <MDBDataTable
          data={tableData}
          scrollX
          scrollY
          maxHeight='250px'
          responsive
          striped
          bordered
          hover
          noRecordsFoundLabel="No existen elementos"
          infoLabel={["Mostrando", "-", "de", "elementos"]}
          paginationLabel={["Atras", "Siguiente"]}
        />
      </CardBody>
    </Card>
  )
}

export default React.memo(DataTable, (prevProps, nextProps) => isEqual(prevProps, nextProps));
